import { SpecialFinancingParams } from '../../components/Configuration/Financing/SpecialFinancing';
import RequestV2 from './request-v2';

export default class SpecialFinancingHttpService {
    private static uri = 'invoice/special-financing';

    public static read() {
        return RequestV2.get(`${this.uri}`, undefined);
    }

    public static update(data: SpecialFinancingParams) {
        return RequestV2.put(`${this.uri}`, data);
    }
}
